import { Card, Typography } from '@dtx-company/design-system/src'
import { CardMedia } from '@mui/material'
import { CodeConfigurationField } from '@dtx-company/inter-app/src/types/flowcode'
import { FC } from 'react'
import { ScanDestinationOption } from './hooks/useScanDestinationOptions'
import { selectScanDestinationType } from '@dtx-company/app/shared/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@dtx-company/app/shared/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'

type ScanDestinationRadioCardProps = ScanDestinationOption

export const ScanDestinationRadioCard: FC<
  ScanDestinationRadioCardProps & { isSmallVariant?: boolean }
> = ({ label, value, Icon: Icon, isSmallVariant = false }) => {
  const { locgService } = useGlobalServices()
  const selectedScanDestinationType = useSelector(locgService, selectScanDestinationType)
  const isSelected = selectedScanDestinationType === value

  const onChange = (): void => {
    locgService.send({ type: 'CHANGE', key: CodeConfigurationField.SCAN_DESTINATION_TYPE, value })
  }

  return (
    <Card
      variant="outlined"
      component="label"
      data-heap-id="LoggedOutGenerator_ScanDestinationTypeInput"
      data-value={value}
      sx={theme => ({
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: isSmallVariant ? 'row' : 'column',
        justifyContent: isSmallVariant ? undefined : 'center',
        alignItems: 'center',
        p: isSmallVariant ? 1.5 : undefined,
        py: isSmallVariant ? undefined : 3,
        boxShadow: isSelected ? theme.shadows[1] : theme.shadows[0],
        ':hover': {
          boxShadow: theme.shadows[1]
        },
        borderRadius: '12px',
        borderColor: isSelected ? 'onSurface.primary' : 'border.divider',
        borderWidth: '1px',
        ...(isSelected && { outline: `1px solid ${theme.palette.onSurface.primary}` }),
        overflow: 'visible', // allow focus ring to be visible
        cursor: 'pointer',
        input: {
          appearance: 'none',
          position: 'absolute',
          inset: 0,
          margin: 0,
          cursor: 'pointer'
        }
      })}
      tabIndex={0}
    >
      <CardMedia
        sx={
          isSmallVariant
            ? {
                display: 'flex',
                alignItems: 'center',
                px: 1.5
              }
            : {}
        }
      >
        <Icon sx={isSmallVariant ? { width: '18px', height: '18px' } : {}} />
      </CardMedia>
      <Typography
        component="span"
        variant={isSmallVariant ? 'labelMedium' : 'labelLarge'}
        noWrap
        align="center"
      >
        {label}
      </Typography>
      <input
        type="radio"
        name={CodeConfigurationField.SCAN_DESTINATION_TYPE}
        value={value}
        onChange={onChange}
      />
    </Card>
  )
}
